import { render, staticRenderFns } from "./MasterSverka.vue?vue&type=template&id=7d082142&scoped=true"
import script from "./MasterSverka.vue?vue&type=script&lang=js"
export * from "./MasterSverka.vue?vue&type=script&lang=js"
import style0 from "./MasterSverka.vue?vue&type=style&index=0&id=7d082142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d082142",
  null
  
)

export default component.exports